<template>
	<Popup
		v-model="selfDisplay"
		title="查看"
		:confirmBtnDisplay="false"
	>
		<div style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>序号</span>
				<el-input :value="order" disabled></el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>分类</span>
				<el-input :value="sort" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>标题</span>
				<el-input :value="title" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>封页图</span>
				<div class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="cover" alt="" style="">
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">发布人</span>
				<el-input :value="publisher" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>内容</span>
				<editor :value="content" :enableEditor="false"></editor>
			</div>
		</div>
	</Popup>
</template>

<script>
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				selfDisplay: false,
				
				order: '',
				sort: '',
				title: '',
				cover: '',
				publisher: '',
				content: ''
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.loading = false;
					this.order = this.obj.order;
					this.sort = this.obj.sortLabel;
					this.title = this.obj.title;
					this.cover = this.obj.cover;
					this.publisher = this.obj.publisher;
					this.content = this.obj.content;
				}
			}
		}
	}
</script>

<style>
</style>
